module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layui-unselect layui-form-switch",
    class: {
      'layui-form-onswitch': _vm.currentValue
    },
    on: {
      "click": _vm.changeSwitch
    }
  }, [_c('i')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59b90bbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmSwitch.vue
// module id = 321
// module chunks = 2